@if (isLoading()) {
  <div class="spinner">
    <mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
  </div>
} @else {
  <!-- Issue Body -->
  <div class="issue">
    <div class="issue-header">
      <div class="issue-header-title">
        <!-- <img class="icon" [src]="./assets/mockData/icons/issue-sidePanel.svg"/> -->
        <div class="issue-header-title-text display-flex" appLongTextTooltip>
          {{ getCapitalizedIssueName() }}
          @if (isLocalAiIssue()) {
            <span class="local-ai-badge" matTooltip="AI Agent Based Analysis" matTooltipPosition="above">
              Local AI
            </span>
          } @else if (isAiGeneratedIssue()) {
            <img
              src="assets/images/status-icons/ai-generated.svg"
              alt="AI Generated"
              class="ai-generated-icon"
              matTooltip="AI Agent Based Analysis"
              matTooltipPosition="above"
            />
          }
        </div>
      </div>

      <div class="issue-header-secondary-title">
        <div class="issue-header-secondary-title-property">Issue</div>
        <div class="separator">|</div>
        <div class="issue-header-secondary-title-property">
          <div>ID</div>
          <app-copy-button
            class="copy-button"
            [value]="issueModel?.id || ''"
            [title]="issueModel?.id || ''"
            [isSecondaryFontColor]="true"
          >
          </app-copy-button>
        </div>
      </div>

      @if (issueModel?.firstSeen || issueModel?.lastSeen) {
        <div class="issue-header-secondary-title">
          @if (issueModel?.firstSeen) {
            <div class="issue-header-secondary-title-property">
              {{ 'First Seen: ' + (issueModel?.firstSeen | date: 'MMM d,y,HH:mm') }}
            </div>
          }
          @if (issueModel?.firstSeen && issueModel?.lastSeen) {
            <div class="separator">|</div>
          }
          @if (issueModel?.lastSeen) {
            <div class="issue-header-secondary-title-property">
              {{ 'Last Seen: ' + (issueModel?.lastSeen | date: 'MMM d,y,HH:mm') }}
            </div>
          }
        </div>
      }

      <app-sidepanel-tabs class="issue-header-tabs" [tabs]="tabs" (tabOnSelection)="onTabSelect($event)">
      </app-sidepanel-tabs>
    </div>

    <div class="issue-body">
      <!-- Overview Tab -->
      @if (activeTabIndex === 0) {
        <div class="issue-body-tab">
          <div class="issue-body-tab-card issue-details-card">
            <div class="issue-body-content">
              <div class="issue-analysis">
                <div class="issue-body-tab-card-title">
                  {{ 'issuesPage.issueAnalysis' | labelsProvider }}
                </div>
                <div>
                  {{ issueModel?.description }}
                </div>
              </div>
              <!-- Vertical Separator -->
              <div class="vertical-separator"></div>

              <div class="issue-body-details">
                <div class="details-item">
                  <div class="details-item-label">Status</div>
                  <div class="details-item-value-wrapper">
                    <div class="details-item-value">
                      @if (isActionLoading()) {
                        <mat-progress-spinner
                          class="status-spinner"
                          color="primary"
                          mode="indeterminate"
                          [diameter]="20"
                        >
                        </mat-progress-spinner>
                      }
                      <app-select-v2
                        class="status-select"
                        [options$]="statusOptions$"
                        [selectedId]="selectedStatusId()"
                        [disabled]="!canEditStatus() || isActionLoading()"
                        (optionOnSelection)="onStatusSelected($event)"
                      >
                      </app-select-v2>
                    </div>
                    @if (issueStatusDescription()) {
                      <div class="status-description" [ngClass]="issueStatusColorClass()">
                        {{ issueStatusDescription() }}
                      </div>
                    }
                  </div>
                </div>
                <div class="details-item">
                  <div class="details-item-label">Severity</div>
                  <app-severity-label [severity]="issueModel?.severity || 'medium'" [smallSize]="true" />
                </div>
                <div class="details-item-primary-resource">
                  <div>Primary Resource</div>
                  @if (issueModel?.platformResourceId) {
                    <app-anchor-link navigation="" (clicked)="navigateToPrimaryResource()" class="field-link-value">
                      <span class="field-link-value__text" appLongTextTooltip>{{ getPrimaryResourceName() }}</span>
                    </app-anchor-link>
                  } @else {
                    <div>{{ getPrimaryResourceName() }}</div>
                  }
                </div>
                <div class="details-item-service-type">
                  <div>AI Service</div>
                  <div class="service-type-container">
                    <img
                      [src]="issueViewModel?.primaryResourceIcon"
                      class="service-type-icon"
                      [alt]="getPrimaryResourceType()"
                    />
                    <span>{{ getPrimaryResourceType() }}</span>
                  </div>
                </div>

                @if (issueModel?.actor && issueModel?.actor?.displayName && issueModel?.actor?.displayName !== 'N/A') {
                  <div class="actor-section">
                    <div class="actor-label">Actor</div>
                    <div class="actor-details">
                      <div class="actor-detail-item">
                        <span class="actor-detail-label">Name:</span>
                        <span class="actor-detail-value">{{ issueModel?.actor?.displayName }}</span>
                        <app-copy-button
                          [value]="issueModel?.actor?.displayName ?? ''"
                          class="actor-copy-button"
                        ></app-copy-button>
                      </div>
                      @if (issueModel?.actor?.email && issueModel?.actor?.email !== 'null') {
                        <div class="actor-detail-item">
                          <span class="actor-detail-label">Email:</span>
                          <span class="actor-detail-value">{{ issueModel?.actor?.email }}</span>
                          <app-copy-button
                            [value]="issueModel?.actor?.email ?? ''"
                            class="actor-copy-button"
                          ></app-copy-button>
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>

          <div *appFeatureFlag="'react_rsa_2026_demo_runtime_boundaries'">
            @if (rsaDemoBannerType) {
              <app-issue-prevention-banner
                [bannerType]="rsaDemoBannerType"
                [issueId]="issueModel?.id || ''"
                (reviewBoundaryClicked)="onReviewBoundaryClicked()"
              />
            }
          </div>

          @if (hasValidPrimaryResource() && integration()) {
            <div class="issue-body-tab-card issue-details-card graph-card">
              <app-accordion
                class="issue-body-tab-card-title"
                [accordionTitle]="'issuesPage.resourceRelationsGraph'"
                [boldTitle]="true"
                [withLabelPipe]="true"
                [expanded]="accordionExpansionStateMapping['issuesPage.resourceRelationsGraph']"
                (accordionExpansionEvent)="updateAccordionExpansionState('issuesPage.resourceRelationsGraph', $event)"
              >
                <app-relations-graph
                  [integrationId]="integration()!"
                  [resourceId]="issueModel!.primaryResource!.id!"
                  [isIssueComponent]="true"
                  (nodeClicked)="onGraphNodeClicked($event)"
                >
                </app-relations-graph>
              </app-accordion>
            </div>
          }

          <div class="issue-body-tab-card issue-details-card">
            <div class="issue-body-tab-card-title-with-action">
              <div class="issue-body-tab-card-title">
                {{ 'issuesPage.issueTimeLine' | labelsProvider }}
              </div>
              <button
                type="button"
                class="fetch-messages-button"
                (click)="onFetchMessagesClick($event)"
                [disabled]="isFetchingMessages() || !hasAnyMessages()"
                [ngClass]="{
                  'button-active': areMessagesExpanded(),
                  'button-disabled': !hasAnyMessages(),
                }"
                [matTooltip]="!hasAnyMessages() ? 'No conversation messages available' : ''"
                matTooltipPosition="left"
              >
                @if (!isFetchingMessages()) {
                  <span>{{ areMessagesExpanded() ? 'Collapse Messages' : 'Fetch Messages Content' }}</span>
                }
                @if (isFetchingMessages()) {
                  <mat-progress-spinner class="button-spinner" color="primary" mode="indeterminate" diameter="16">
                  </mat-progress-spinner>
                  <span>Loading...</span>
                }
              </button>
            </div>

            @if (sensitiveDataFetchErrors().length > 0) {
              <div class="error-message">
                <div class="error-header">
                  ⚠️ Failed to load sensitive data for {{ sensitiveDataFetchErrors().length }} item{{
                    sensitiveDataFetchErrors().length > 1 ? 's' : ''
                  }}
                </div>
                <ul class="error-list">
                  @for (error of sensitiveDataFetchErrors(); track error) {
                    <li [matTooltip]="error" matTooltipPosition="right">
                      {{ getTruncatedError(error) }}
                    </li>
                  }
                </ul>
              </div>
            }

            <app-timeline-issue
              #timelineComponent
              [timelineIssueItems]="timelineItems"
              (itemClicked)="onTimelineItemClicked($event)"
            ></app-timeline-issue>
          </div>

          @if (isLoadingTimelineData()) {
            <div class="issue-body-tab-card issue-details-card findings-violations-section">
              <div class="issue-body-tab-card-title">Related Findings/Violations</div>
              <div class="findings-loading-skeleton">
                <div class="skeleton-row"></div>
                <div class="skeleton-row"></div>
                <div class="skeleton-row"></div>
              </div>
            </div>
          } @else if (relatedFindings().length > 0 || relatedViolations().length > 0) {
            <div class="issue-body-tab-card issue-details-card findings-violations-section">
              <div class="issue-body-tab-card-title">
                Related Findings/Violations ({{ relatedFindings().length + relatedViolations().length }})
              </div>

              <app-prime-table
                queryParamProperty="item"
                [data$]="combinedTableData$"
                [rowsPerPage]="50"
                [columns]="combinedTableColumns()"
                [isLoading]="false"
                [withCheckboxSelection]="false"
                [sortedColumn$]="sortedColumn$"
                [pageInfo]="{
                  number: 1,
                  currSize: relatedFindings().length + relatedViolations().length,
                  maxSize: 50,
                  totalItems: relatedFindings().length + relatedViolations().length,
                  totalPages: 1,
                }"
                tableNotFoundText="No items found"
                tableNotFoundIcon="assets/images/common/no-results-found.svg"
                (rowSelected)="onItemRowSelected($event)"
                (rowUnselected)="onItemRowUnselected()"
              />
            </div>
          }
        </div>
      }

      <!-- Remediation Tab -->
      @if (activeTabIndex === 1) {
        <div class="issue-body-tab">
          @if (getRemediation(); as remediation) {
            <div class="issue-body-tab-card issue-details-card">
              <div class="remediation-content">
                <div class="issue-body-tab-card-title">
                  {{ remediation.title }}
                </div>
                @if (remediation.instructions) {
                  <ol class="remediation-instructions-list">
                    @for (instruction of getRemediationInstructions(remediation.instructions); track $index) {
                      <li>{{ instruction }}</li>
                    }
                  </ol>
                }
              </div>
            </div>
          } @else {
            <div class="issue-body-tab-card issue-details-card">
              <div class="no-remediation">
                <p>No remediation available for this issue.</p>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>

  <!-- Floating Feedback Panel -->
  @if (!feedbackPanelClosed()) {
    <app-floating-feedback-panel
      [feedbackSubmitted]="feedbackSubmitted()"
      [feedbackChoice]="feedbackChoice()"
      [feedbackComment]="feedbackComment()"
      [feedbackError]="feedbackError()"
      [isSubmittingFeedback]="isSubmittingFeedback()"
      (feedbackClicked)="onFeedbackClick($event.helpful, $event.event)"
      (feedbackCommentChanged)="onFeedbackCommentChange($event)"
      (feedbackSubmit)="onSubmitFeedback($event)"
      (closed)="onFeedbackPanelClose()"
    />
  }

  @if (showBoundaryPopup && boundaryPopupData) {
    <app-boundary-review
      [issueId]="boundaryPopupData.issueId"
      [issueName]="boundaryPopupData.issueName"
      [issueSeverity]="boundaryPopupData.issueSeverity"
      [issueResourceIcon]="boundaryPopupData.issueResourceIcon"
      (closed)="onBoundaryPopupClosed()"
    />
  }
}
